import gql from 'graphql-tag';

import GraphQLClient from '../../adapter/GraphQLClient';
import { SingleCreationSetFragment } from './../../generated/graphql';

const singleCreationSetFragment = gql`
  fragment SingleCreationSet on CreationSet {
    id
    creativeFormats {
      id
      network {
        id
        key
        name
      }
      placement {
        id
        key
        name
      }
      creativeType {
        id
        key
        name
      }
      attribute {
        aspectRatio {
          supportingAspectRatioId
          aspectRatio {
            width
            height
          }
          size {
            width
            height
          }
        }
        playbackTime {
          supportingPlaybackTimeId
          seconds
        }
      }
      resizeBaseId
    }
    creations {
      id
      assignee {
        id
        name
        profileImageUrl
      }
      deliverables {
        id
        creative {
          id
          file {
            id
            originalFileName
            url
            mimeType
            size
          }
        }
        intent
        state
        createdAt
        stateUpdatedAt
      }
      modificationRequests {
        id
        bucketId
        state
        targetDeliverableId
        feeType
        createdAt
        submittedAt
        approvedAt
        deliveryDue
        feedback {
          id
          body
          createdAt
        }
        sender {
          id
          name
          profileImageUrl
        }
        items {
          id
          type
          typeName
          assetIds
          body
          metadata
          sender {
            id
            name
            profileImageUrl
          }
          issue {
            id
            name
            resolved
            comments {
              id
              body
              assetIds
              createdAt
              user {
                ... on UserDirector {
                  id
                  name
                  email
                  profileImageUrl
                }
                ... on UserOptimizer {
                  id
                  name
                  email
                  profileImageUrl
                }
              }
            }
          }
        }
        deliverables {
          id
          createdAt
          creative {
            id
            file {
              id
              originalFileName
              url
              mimeType
              size
            }
          }
          attachedThumbnail {
            id
            file {
              id
              originalFileName
              url
              mimeType
              size
            }
          }
          intent
        }
      }
      creativeFormat {
        id
        network {
          id
          key
          name
        }
        placement {
          id
          key
          name
        }
        creativeType {
          id
          key
          name
        }
        attribute {
          aspectRatio {
            supportingAspectRatioId
            aspectRatio {
              width
              height
            }
            size {
              width
              height
            }
          }
          playbackTime {
            supportingPlaybackTimeId
            seconds
          }
        }
        resizeBaseId
      }
      state
      createdAt
      stateUpdatedAt
    }
    amount
    deliveryDueDate
    deliveryDueDays
    expressDueDays
  }
`;

class CreationSetWebApi {
  private readonly graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public getByIdWithoutPricingData = async (creationSetId: string): Promise<SingleCreationSetFragment> => {
    const result = await this.graphqlClient.query(
      gql`
        ${singleCreationSetFragment}
        query getCreationSetById($creationSetId: ID!) {
          creationSet(id: $creationSetId) {
            ...SingleCreationSet
          }
        }
      `,
      { creationSetId },
    );

    return result.creationSet as SingleCreationSetFragment;
  };
}

export default CreationSetWebApi;
